module.exports = __webpack_public_path__ + "img/roltek-print-logo.18816bc3.png";